import { render, staticRenderFns } from "./prdStatusTag.vue?vue&type=template&id=44718ced&scoped=true&"
import script from "./prdStatusTag.vue?vue&type=script&lang=js&"
export * from "./prdStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./prdStatusTag.vue?vue&type=style&index=0&id=44718ced&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44718ced",
  null
  
)

export default component.exports